/**
 * Технические ключи GPS-трекера (не числа баланса).
 */

/** Ключ localStorage для очереди неотправленных пакетов. */
export const GPS_OFFLINE_STORAGE_KEY = "hive.trace.pendingBatches";
